import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const LaunchGameMessage = (props) => {

  return (
    <div className='popup-box'>
      <h4 className="title">{props.t('confirmation_required')}</h4>
      <p>{props.t("you_are_already_playing_a_game_in_another_tab")}. {props.t("do_you_want_to_close_the_current_game_and_launch_a_new_one")}?</p>
      <div className="text-center pt-1 d-flex gap-2 justify-content-center">
        <button onClick={() => props.confirmRelaunch()}>
          {props.t("yes")}
        </button>
        <button onClick={() => props.cancelRelaunch()}>
          {props.t("no")}
        </button>
      </div>
    </div >
  );
}

LaunchGameMessage.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(LaunchGameMessage);
